import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorDialogProps {
	open: boolean;
	title: string;
	message: string;
	onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, title, message, onClose }) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<Typography>{message}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="secondary" variant="contained">
					{t("common.ok")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ErrorDialog;
